import gql from "graphql-tag";

export const CUSTOMER_INFO = gql`
  query customerInfo {
    customerInfo {
      civilityCode
      name
      firstname
      fullname
      address1
      address2
      postCode
      town
      countryCode
      cellPhone
      phone
      civilityDesc
      countryDesc
      email
      languageCode
      languageDesc
      geolocalized
      dataList {
        name
        value
      }
    }
  }
`;
